<template>
    <div class="wrap preview tbl">
        <!-- [D] HEADER -->
        <div class="header tbl_row">
            <button type="button" class="btn_close" @click="closePreviewImage"><span class="sp">{{$t('PreviewImage_close')}}</span></button>
            <span class="tit">{{ nowOrderNo + 1 }} / {{ attachments.length }}</span>
            <a :href="imageDownloadUrl" class="btn_down" download target="_blank" v-if="device !== IOS"><span class="sp">{{$t('PreviewImage_download')}}</span></a>
        </div>
        <div class="tbl_row">
            <div class="tbl_cell">
                <button type="button" class="btn_prev" v-show="nowOrderNo !== 0" @click="onClickPrev"><span class="sp">{{$t('PreviewImage_prev')}}</span></button>
                <!-- [D] swipe area -->
                <div class="swipe_area" ref="zoom">
                    <span class="img" v-for="attachment in attachments" v-show="attachment.orderNo === nowOrderNo"><img ref="img" :src="attachment.image.url" alt=""></span>
                </div>
                <!-- //[D] swipe area -->
                <button type="button" class="btn_next" v-show="nowOrderNo !== attachments.length - 1" @click="onClickNext"><span class="sp">{{$t('PreviewImage_next')}}</span></button>
            </div>
        </div>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import {checkUserAgent, IOS} from '@/iamteacherpc/utils/checkMobileDevice.js';
    import PinchZoom from "pinch-zoom-js";

    const { mapActions } = createNamespacedHelpers('response');

    export default {
        name: "ImagePreview",

        props: {
            order: {
                type: Number,
                required: true
            },

            attachments: {
                type: Array,
                required: true
            }
        },

        metaInfo() {
            const title = this.$t('common_previewImage');
            return {title}
        },

        data() {
            return {
                nowOrderNo: this.order,
                IOS: IOS,
                zoom: null
            };
        },

        watch: {
            nowOrderNo(newValue) {
                this.$nextTick(() => {
                    this.zoom.zoomFactor = 1;
                    window.dispatchEvent(new Event('resize'));
                });

                this.$eventBus.$emit('changeFileImageOrder', {order: newValue});
            }
        },

        computed: {
            imageDownloadUrl() {
                const originUrl = this.attachments[this.nowOrderNo].image.url;
                return `${process.env.VUE_APP_CONTENTS_SERVER_URL}/download/external/image/exchange?imagePath=${encodeURI(originUrl)}`;
            },

            device() {
                return checkUserAgent();
            },
        },

        methods: {
            closePreviewImage() {
                this.$router.go(-1);
            },

            onClickPrev() {
                this.nowOrderNo -= 1;
            },
            onClickNext() {
                this.nowOrderNo += 1;
            },
        },

        mounted() {
            this.$nextTick(() => {
                this.zoom = new PinchZoom(this.$refs.zoom, {
                    draggableUnzoomed: false
                });
            });
        }
    }
</script>
